export function FeaturesPage() {
  const features = [
    {
      title: "CSV Import & Column Mapper",
      description:
        "Upload voter files from any source. Our drag-and-drop mapper matches your columns to the standard schema in seconds. Raw data is always preserved.",
    },
    {
      title: "Survey & Tag Builder",
      description:
        "Build custom survey questions with flexible response-to-tag mapping. No hardcoded support levels — define the metrics that matter for your race.",
    },
    {
      title: "Walkbook Creation",
      description:
        "Generate door-to-door routes sorted by address. Attach scripts and surveys to walkbooks and assign them to volunteers with one click.",
    },
    {
      title: "Real-time Map View",
      description:
        "See where your team is and which doors have been knocked in real time. Powered by PostGIS for accurate spatial queries.",
    },
    {
      title: "Offline-first Mobile PWA",
      description:
        "Volunteers work without signal. Interactions are queued in IndexedDB and synced automatically when connectivity returns.",
    },
    {
      title: "Reporting & Exports",
      description:
        "Track contact rates, support scores, and volunteer productivity. Export to CSV or PDF for your campaign manager or field director.",
    },
  ];

  return (
    <div className="max-w-6xl mx-auto px-6 py-20 space-y-16">
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-bold tracking-tight">Everything your field team needs</h1>
        <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
          Built for political campaigns that take door-knocking seriously.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        {features.map((f) => (
          <div key={f.title} className="rounded-lg border p-6 space-y-2">
            <h3 className="font-semibold">{f.title}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">{f.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
